export type WorkspaceSettingsSectionId =
  | "general"
  | "members"
  | "org-context"
  | "audit-defaults"
  | "manage";

type WorkspaceSettingsSectionConfig = {
  id: WorkspaceSettingsSectionId;
  labelKey: string;
  ownerOnly?: boolean;
};

export const WORKSPACE_SETTINGS_SECTIONS: readonly WorkspaceSettingsSectionConfig[] =
  [
    { id: "general", labelKey: "workspace.sections.general" },
    { id: "members", labelKey: "workspace.members.title" },
    { id: "org-context", labelKey: "workspace.orgContext.title" },
    { id: "audit-defaults", labelKey: "workspace.auditDefaults.title" },
    { id: "manage", labelKey: "dangerZone.title", ownerOnly: true },
  ];

export function scrollToWorkspaceSection(sectionId: WorkspaceSettingsSectionId) {
  const el = document.getElementById(sectionId);
  if (!el) return;

  el.scrollIntoView({ behavior: "smooth", block: "start" });

  const nextHash = `#${sectionId}`;
  if (window.location.hash !== nextHash) {
    window.history.replaceState(null, "", nextHash);
  }
}
